import { defineStore } from 'pinia'
import { ref } from 'vue'

export const usePdfViewer = defineStore('PdfViewer', () => {
  const showPdfViewer = ref(true)

  function togglePdfViewer(): void {
    showPdfViewer.value = !showPdfViewer.value
  }

  return {
    showPdfViewer,
    togglePdfViewer,
  }
})
